import React, { useEffect, useState } from 'react';
import CommentThread from '../../../shared/components/comments/CommentThread';
import {
  createSupplierNoteResult,
  deleteSupplierNoteResult,
  listSupplierNotesResult,
} from '../services/suppliers.service';

export default function SupplierNotesPanel({ supplier }) {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;

    async function loadNotes() {
      setIsLoading(true);
      setError('');
      const result = await listSupplierNotesResult(supplier.id);
      if (!active) return;
      const ok = result?.ok === true;
      setComments(ok ? result.data : []);
      setError(ok ? '' : result?.message || 'Commenti fornitore non disponibili.');
      setIsLoading(false);
    }

    loadNotes();
    return () => {
      active = false;
    };
  }, [supplier.id]);

  async function submitComment(payload) {
    const body = String(payload?.body || '').trim();
    if (!body || isSubmitting) return { ok: false };

    setIsSubmitting(true);
    setError('');
    const result = await createSupplierNoteResult(supplier.id, body);
    setIsSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Commento fornitore non salvato.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  async function submitReply(parentId, payload) {
    const body = String(payload?.body || '').trim();
    if (!body || !parentId || isSubmitting) return { ok: false };

    setIsSubmitting(true);
    setError('');
    const result = await createSupplierNoteResult(supplier.id, body, parentId);
    setIsSubmitting(false);

    if (!result.ok) {
      setError(result.message || 'Risposta fornitore non salvata.');
      return result;
    }

    setComments((prev) => [...prev, result.data]);
    return result;
  }

  async function deleteComment(comment) {
    const commentId = comment?.id ?? comment;
    const result = await deleteSupplierNoteResult(supplier.id, commentId);
    if (!result.ok) {
      setError(result.message || 'Commento fornitore non eliminato.');
      return result;
    }
    setComments((prev) => prev.filter((comment) => String(comment.id) !== String(commentId)));
    return result;
  }

  return (
    <CommentThread
      title="Commenti"
      comments={comments}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      error={error}
      emptyLabel="Nessun commento fornitore."
      placeholder="Aggiungi un commento fornitore..."
      submitLabel="Aggiungi commento"
      onSubmitComment={submitComment}
      onSubmitReply={submitReply}
      onDeleteComment={deleteComment}
      allowReplies
      entityType="supplier"
      entityId={supplier.id}
    />
  );
}
